import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit, doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";
import { Helmet } from "react-helmet";
import Loadingimg from '../components_root/loadingimg.jsx';
import Loading_items from "../components_root/loading_items.jsx";
import logo_default from "../assets/logo_default.jpg";
import Slideshow_Viewer from "./slideshow_viewer.js";
import Rating from "../view_root/rating.js";
import { RiShoppingCartLine } from "react-icons/ri";
import { IoIosGitCompare } from "react-icons/io";
import Loading from "../components_root/loading.jsx";
import { CiRead } from "react-icons/ci";
import banner_default from "../assets/banner_default.jpg";
import Saved from "../view_root/saved.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext.jsx";
import Add_cart from "../cart_root/add_cart.js";
import HomeSlideshow from "./homeslideshow.js";
import './home.css';
import BrandSlider from "./BrandSlider.jsx";
import Chart_details from "../cart_root/chart_details.jsx";
import Bar_code from "../components_root/bar_code.js";
import { MdLocalActivity, MdLocationPin, MdPrint } from "react-icons/md";
import ShareButton from "../components_root/ShareButton.jsx";
import Print_receipt_order from "../accounting_root/print_root/print_receipt_order.js";
import MapView from "../components_root/map_view.js";
import Ledger_accounts_full_profile from "../company_root/staff_account_root/ledger_accounts_full_profile.jsx";
export const seoFallback = {
  title: "AOOZ Accounting Software | Web & Mobile App for Payments, Stocks, Inventory & Staff Attendance",
  description: "AOOZ is a complete accounting software with web and mobile apps. Manage payments, stocks, staff attendance, inventory, and generate online share receipts. A powerful all-in-one platform for businesses.",
  keywords: "AOOZ accounting software, business accounting app, payment management, stock tracking, inventory software, staff attendance system, online share receipt, web accounting app, mobile accounting app",
  url: "https://aooz.in",
  image: "https://aooz.in/assets/logo.png"
};

export default function Download_receipt({ data }) {
  const { Toastshow } = Toast();
  const navigate = useNavigate();
  const [IsLoading2, setIsLoading2] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [brandnamedata, setBrandnameData] = useState([]);
  const [titlemete, setTitlemete] = useState("");
  const [keywordsmete, setKeywordsmete] = useState("");
  const [products_new_data, setProducts_new_data] = useState([]);
  const [vouchersdata, setVouchersdata] = useState([]);
  const [companydata, setCompanydata] = useState([]);


  useEffect(() => {
    const checkIntegration = async () => {
      try {
        const checkQuery = query(
          collection(db, "companies"),
          where("companyuid", "==", data.companyuid)
        );
        const checkSnap = await getDocs(checkQuery);
        if (checkSnap.empty) {

          return;
        }

        const dataList = checkSnap.docs.map(doc => ({
          uid: doc.id,
          ...doc.data()
        }));

        setCompanydata(dataList);

      } catch (err) {
        console.error("Error checking API integration:", err);
      }
    };

    if (data) {
      checkIntegration();
    }
  }, [data]);


  const meta = {
    title: titlemete || seoFallback.title,
    description: seoFallback.description,
    keywords: keywordsmete || seoFallback.keywords,
    image: seoFallback.image,
    url: `https://aooz.in`,
  };
  const [printId, setPrintId] = useState();

  const PrintReceiptVoucher = (id) => {
    setPrintId(id);
  };

  return (
    <div  >

      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:url" content={meta.url} />
      </Helmet>
      {/* <div >
        <HomeSlideshow slideshow_filedata={review_slideshow_filedata}
          banner_default={banner_default}
          navigate={navigate} />
      </div> */}
      {/* brandname */}
      <div className="container_roots ">
        <div className="container_contant">

          <div className="post-container m-top">
            <div className="post_div">
              <div className="p-1 m-top">

                <table>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td className="text-hero-sub fcap bold">{companydata[0]?.company}</td>
                        </tr>
                        <tr>
                          <td className="text-h2 fcap">{companydata[0]?.address || ""}</td>
                        </tr>
                        <tr>
                          <td className="text-h2 fcap">Phone : {companydata[0]?.code || ""}{companydata[0]?.phone || "N/A"}</td>
                        </tr>
                      </table>
                    </td>
                    <td width={40}>

                      <td width={30} ><ShareButton url={data.slug} /></td>
                      <td width={40}>

                        <div className="button-ui0 cursor"
                          onClick={() => {
                            PrintReceiptVoucher(data.voucherprintid);

                          }}

                        ><MdPrint className="icon" /></div></td>
                    </td>
                  </tr>
                </table>

              </div>
              <div className="m-top ">
                <div className="items-back-fill p-1">

                  <div className="center text-h1 fcap bold">
                    {data.voucher_type}
                  </div>
                  <table >
                    <tbody>
                      <tr>
                        <td>
                          <table className="text-l">
                            <tr><td> <div className="text-h2 cap bold">Tokenn #{data.tokennumber || ""}</div></td></tr>

                            <tr><td className="text-h3"># {data.vouchernumber}</td></tr>
                          </table>
                        </td>
                        <td width={180}>
                          <table>
                            <tr><td className="bold text-h1 text-r fcap">{data.voucher}</td></tr>
                            <tr><td className="text-h3 text-r ">Date:

                              {data.date_time?.toDate ? (
                                <>
                                  {data.date_time.toDate().toLocaleDateString()}{" "}
                                  {data.date_time.toDate().toLocaleTimeString()}
                                </>
                              ) : (
                                "No date"
                              )}
                            </td></tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>

                <div className=" p-1 m-top items-back">
                  <table>
                    <tr>
                      <td>
                        <div className="text-h1 bold fcap">
                          {data.namepaying || "Name n/a"}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="text-h2 bold ">
                          {data.mobile || ""}
                        </div>
                      </td>
                    </tr>
                    <tr>

                      <td>
                        <div className="text-h3 fcap">
                          {data.addresspaying || ""}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div className="line-t  p-1 m-top items-back">
                  <table className="text-h2">
                    <tbody>
                      <tr>
                        <td className="text-h2 bold">{data.voucher}</td>
                        <td className="text-h1 bold" style={{ textAlign: "right" }}>
                          ₹ {data.amount}/-
                        </td>
                      </tr>
                      {data.ledger_manager_items &&
                        data.ledger_manager_items.length > 0 && (
                          data.ledger_manager_items
                            .filter(item => item.account_type === "charges")
                            .map((item, index) => (
                              <tr key={index}>
                                <td>{item.managename || item.voucher}</td>
                                <td className="amount-text" style={{ textAlign: "right" }}>
                                  ₹ {item.manageacalc} {item.amount}/- {item.mathedcalc}
                                </td>
                              </tr>
                            ))
                        )
                      }
                      <tr>
                        <td>
                          {data.refer_number && `Refer No.: ${data.refer_number}`}
                        </td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>{data.remarks || data.description}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                </div>
                <div className="p-1 m-top items-back-fill">
                  <table className="text-h1 bold">
                    <tr>
                      <td><b>TOTAL AMOUNT</b></td>
                      <td style={{ textAlign: "right" }}>
                        <b>₹ {data.totalamount}/-</b>
                      </td>
                    </tr>
                  </table>
                </div>

                <div className="center">
                  <div className="footer-text">THANK YOU</div>
                  <div className="barcode">
                    <Bar_code value={data.vouchernumber} />
                  </div>
                  <div className="info-text bold">Print By: Aooz.in</div>
                </div>

                <div className="items-back b-1 rounded text-h2 m-top">
                  <div className="p-11 ">                  
                  <div className="p-2 text-h2 fcap center  b-bottom ">This {data.voucher_type} location is authorized by the authority.</div>
                  <Ledger_accounts_full_profile accountguid={data.accountguid_authority} />
                  <table>
                    <tr>
                      <td width={30}><MdLocationPin className="icon" /></td>
                      <td>
                        {data.address || "N/A"}
                      </td>
                      <td>
                        {data.city || "N/A"} -  {data.postcode || "N/A"}
                      </td>
                      <td>
                        {data.state || "N/A"} / {data.country || "N/A"}
                      </td>
                    </tr>
                  </table>
                  </div>
                  <div>
                    <MapView userlatitude={data.latitude} userlongitude={data.longitude} />
                  </div>
                </div>
              </div>
            </div>   </div>

        </div>
         <br/>
               
      </div>
      {printId && (
        <Print_receipt_order voucherprintid={printId} />
      )}
    </div>
  );
}
